import { auth } from '../firebase';

export async function authFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('You must be signed in to use the API.');
  }

  const token = await user.getIdToken();
  const authHeader = { Authorization: `Bearer ${token}` };
  init.headers = {
    ...init.headers,
    ...authHeader,
  };
  return fetch(input, init );
}

export async function authDownload(input: RequestInfo | URL, fileName: string): Promise<void> {
  const response = await authFetch(input);
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
